var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{ref:"permitsduetable",attrs:{"table-ref":"permitsduetable","title":"Permits","icon":"fa fa-list","hide-org-badge":"","show-search":false,"url":'/permits/site/' + _vm.rowData.id,"fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }